import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import superAdminRequestListsService from "./requestListsService"

interface RequestListsStateTypes {
  fetchRequestLists: {
    requestListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchONRoles: {
    ONRolesListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchONSpecialities: {
    ONSpecialitiesListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchONMemberShipPlans: {
    mombershipPlanListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  acceptOrRejectRequest: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  addONUser: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  editONRequest: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  registerMembership: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  deleteONUserRequest: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchONUserDetails: {
    userDetailsData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  licenseApproveOrReject: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  editLicense: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  uploadUsers: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  checkNetworkDuplication: {
    checkNetworkDuplicationData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
};

const initialState: RequestListsStateTypes = {
  fetchRequestLists: {
    requestListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchONRoles: {
    ONRolesListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchONSpecialities: {
    ONSpecialitiesListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchONMemberShipPlans: {
    mombershipPlanListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  acceptOrRejectRequest: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  addONUser: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  editONRequest: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  registerMembership: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  deleteONUserRequest: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchONUserDetails: {
    userDetailsData: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  licenseApproveOrReject: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  editLicense: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  uploadUsers: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  checkNetworkDuplication: {
    checkNetworkDuplicationData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
}


export const fetchRequestLists = createAsyncThunk(
  "requestLists/fetchRequestLists",
    async ({ searchQuery, status, page }: { searchQuery: string; status: string; page:any }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.fetchRequestLists(
        { searchQuery, status, page },
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const acceptOrRejectRequest = createAsyncThunk(
  "requestLists/acceptOrRejectRequest",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;
      const response = await superAdminRequestListsService.acceptOrRejectRequest(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchONRoles = createAsyncThunk(
  "requestLists/fetchONRoles",
    async ({}: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.fetchONRoles(
        {},
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const fetchONSpecialities = createAsyncThunk(
  "requestLists/fetchONSpecialities",
  async ({ roleIDs }: { roleIDs: string }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.fetchONSpecialities(
        { roleIDs },
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
  

export const addONUser = createAsyncThunk(
  "requestLists/addONUser",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.addONUser(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editONRequest = createAsyncThunk(
  "requestLists/editONRequest",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.editONRequest(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const registerMembership = createAsyncThunk(
  "requestLists/registerMembership",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.registerMembership(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createNetwork = createAsyncThunk(
  "requestLists/createNetwork",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.createNetwork(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteONUserRequest = createAsyncThunk(
  "requestLists/deleteONUserRequest",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.deleteONUserRequest(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchONUserDetails = createAsyncThunk(
  "requestLists/fetchONUserDetails",
  async (userId: string, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.fetchONUserDetails(userId, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const licenseApproveOrReject = createAsyncThunk(
  "requestLists/licenseApproveOrReject",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.licenseApproveOrReject(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editLicense = createAsyncThunk(
  "requestLists/editLicense",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.editLicense(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const uploadUsers = createAsyncThunk(
  "requestLists/uploadUsers",
  async (payload: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.uploadUsers(payload, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchONMemberShipPlans = createAsyncThunk(
  "requestLists/fetchONMemberShipPlans",
  async ({ networkTypeID }: { networkTypeID: string }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.fetchONMemberShipPlans(
        { networkTypeID },
        token
      );
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const checkNetworkDuplication = createAsyncThunk(
  "requestLists/checkNetworkDuplication",
  async ({ name }: { name: string }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state?.superAdminAuth?.superAdminUser?.access_token;

      const response = await superAdminRequestListsService.checkNetworkDuplication({ name }, token);
      if (response.isSuccess) {
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const requestLIstsSlice = createSlice({
  name: "requestLists",
  initialState,
  reducers: {
    resetFetchRequestLists: (state) => {
      state.fetchRequestLists = initialState.fetchRequestLists;
    },

    resetAcceptOrRejectRequest: (state) => {
      state.acceptOrRejectRequest = initialState.acceptOrRejectRequest;
    },
    resetAddONUser: (state) => {
      state.addONUser = initialState.addONUser;
    },
    resetEditONRequest: (state) => {
      state.editONRequest = initialState.editONRequest;
    },
    resetRegisterMembership: (state) => {
      state.registerMembership = initialState.registerMembership;
    },
    resetFetchONRoles: (state) => {
      state.fetchONRoles = initialState.fetchONRoles;
    },
    resetFetchONSpecialities: (state) => {
      state.fetchONSpecialities = initialState.fetchONSpecialities;
    },
    resetFetchONMemberShipPlans: (state) => {
      state.fetchONMemberShipPlans = initialState.fetchONMemberShipPlans;
    },
    resetDeleteONUserRequest: (state) => {
      state.deleteONUserRequest = initialState.deleteONUserRequest;
    },
    resetFetchONUserDetails: (state) => {
      state.fetchONUserDetails = initialState.fetchONUserDetails;
    },
    resetLicenseApproveOrReject: (state) => {
      state.licenseApproveOrReject = initialState.licenseApproveOrReject;
    },
    resetEditLicense: (state) => {
      state.editLicense = initialState.editLicense;
    },
    resetUploadUsers: (state) => {
      state.uploadUsers = initialState.uploadUsers;
    },
    resetCheckNetworkDuplication: (state) => {
      state.checkNetworkDuplication = initialState.checkNetworkDuplication;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchRequestLists.pending, (state, action: PayloadAction<any>) => {
        state.fetchRequestLists.isLoading = true;
      })
      .addCase(fetchRequestLists.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchRequestLists.isLoading = false;
        state.fetchRequestLists.isSuccess = true;
        state.fetchRequestLists.message = action.payload.message;
        state.fetchRequestLists.requestListData = action.payload.result;
      })
      .addCase(fetchRequestLists.rejected, (state, action: PayloadAction<any>) => {
        state.fetchRequestLists.isLoading = false;
        state.fetchRequestLists.isError = true;
        state.fetchRequestLists.message = action.payload;
      })

      .addCase(fetchONRoles.pending, (state, action: PayloadAction<any>) => {
        state.fetchONRoles.isLoading = true;
      })
      .addCase(fetchONRoles.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchONRoles.isLoading = false;
        state.fetchONRoles.isSuccess = true;
        state.fetchONRoles.message = action.payload.message;
        state.fetchONRoles.ONRolesListData = action.payload.result;
      })
      .addCase(fetchONRoles.rejected, (state, action: PayloadAction<any>) => {
        state.fetchONRoles.isLoading = false;
        state.fetchONRoles.isError = true;
        state.fetchONRoles.message = action.payload;
      })
      .addCase(fetchONSpecialities.pending, (state, action: PayloadAction<any>) => {
        state.fetchONSpecialities.isLoading = true;
      })
      .addCase(fetchONSpecialities.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchONSpecialities.isLoading = false;
        state.fetchONSpecialities.isSuccess = true;
        state.fetchONSpecialities.message = action.payload.message;
        state.fetchONSpecialities.ONSpecialitiesListData = action.payload.result;
      })
      .addCase(fetchONSpecialities.rejected, (state, action: PayloadAction<any>) => {
        state.fetchONSpecialities.isLoading = false;
        state.fetchONSpecialities.isError = true;
        state.fetchONSpecialities.message = action.payload;
      })

      .addCase(fetchONMemberShipPlans.pending, (state, action: PayloadAction<any>) => {
        state.fetchONMemberShipPlans.isLoading = true;
      })
      .addCase(fetchONMemberShipPlans.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchONMemberShipPlans.isLoading = false;
        state.fetchONMemberShipPlans.isSuccess = true;
        state.fetchONMemberShipPlans.message = action.payload.message;
        state.fetchONMemberShipPlans.mombershipPlanListData = action.payload.result;
      })
      .addCase(fetchONMemberShipPlans.rejected, (state, action: PayloadAction<any>) => {
        state.fetchONMemberShipPlans.isLoading = false;
        state.fetchONMemberShipPlans.isError = true;
        state.fetchONMemberShipPlans.message = action.payload;
      })


      .addCase(acceptOrRejectRequest.pending, (state, action: PayloadAction<any>) => {
        state.acceptOrRejectRequest.isLoading = true;
      })
      .addCase(acceptOrRejectRequest.fulfilled, (state, action: PayloadAction<any>) => {
        state.acceptOrRejectRequest.isLoading = false;
        state.acceptOrRejectRequest.isSuccess = true;
        state.acceptOrRejectRequest.message = action.payload.message;
      })
      .addCase(acceptOrRejectRequest.rejected, (state, action: PayloadAction<any>) => {
        state.acceptOrRejectRequest.isLoading = false;
        state.acceptOrRejectRequest.isError = true;
        state.acceptOrRejectRequest.message = action.payload;
      })
      .addCase(addONUser.pending, (state, action: PayloadAction<any>) => {
        state.addONUser.isLoading = true;
      })
      .addCase(addONUser.fulfilled, (state, action: PayloadAction<any>) => {
        state.addONUser.isLoading = false;
        state.addONUser.isSuccess = true;
        state.addONUser.message = action.payload.message;
      })
      .addCase(addONUser.rejected, (state, action: PayloadAction<any>) => {
        state.addONUser.isLoading = false;
        state.addONUser.isError = true;
        state.addONUser.isSuccess = false;
        state.addONUser.message = action.payload;
      })

      .addCase(editONRequest.pending, (state, action: PayloadAction<any>) => {
        state.editONRequest.isLoading = true;
      })
      .addCase(editONRequest.fulfilled, (state, action: PayloadAction<any>) => {
        state.editONRequest.isLoading = false;
        state.editONRequest.isSuccess = true;
        state.editONRequest.message = action.payload.message;
      })
      .addCase(editONRequest.rejected, (state, action: PayloadAction<any>) => {
        state.editONRequest.isLoading = false;
        state.editONRequest.isError = true;
        state.editONRequest.message = action.payload;
      })

      .addCase(registerMembership.pending, (state, action: PayloadAction<any>) => {
        state.registerMembership.isLoading = true;
      })
      .addCase(registerMembership.fulfilled, (state, action: PayloadAction<any>) => {
        state.registerMembership.isLoading = false;
        state.registerMembership.isSuccess = true;
        state.registerMembership.message = action.payload.message;
      })
      .addCase(registerMembership.rejected, (state, action: PayloadAction<any>) => {
        state.registerMembership.isLoading = false;
        state.registerMembership.isError = true;
        state.registerMembership.message = action.payload;
      })

      .addCase(deleteONUserRequest.pending, (state, action: PayloadAction<any>) => {
        state.deleteONUserRequest.isLoading = true;
      })
      .addCase(deleteONUserRequest.fulfilled, (state, action: PayloadAction<any>) => {
        state.deleteONUserRequest.isLoading = false;
        state.deleteONUserRequest.isSuccess = true;
        state.deleteONUserRequest.message = action.payload.message;
      })
      .addCase(deleteONUserRequest.rejected, (state, action: PayloadAction<any>) => {
        state.deleteONUserRequest.isLoading = false;
        state.deleteONUserRequest.isError = true;
        state.deleteONUserRequest.message = action.payload;
      })
      .addCase(fetchONUserDetails.pending, (state, action: PayloadAction<any>) => {
        state.fetchONUserDetails.isLoading = true;
      })
      .addCase(fetchONUserDetails.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchONUserDetails.isLoading = false;
        state.fetchONUserDetails.isSuccess = true;
        state.fetchONUserDetails.message = action.payload.message;
        state.fetchONUserDetails.userDetailsData = action.payload.result;
      })
      .addCase(fetchONUserDetails.rejected, (state, action: PayloadAction<any>) => {
        state.fetchONUserDetails.isLoading = false;
        state.fetchONUserDetails.isError = true;
        state.fetchONUserDetails.message = action.payload;
      })
      .addCase(licenseApproveOrReject.pending, (state, action: PayloadAction<any>) => {
        state.licenseApproveOrReject.isLoading = true;
      })
      .addCase(licenseApproveOrReject.fulfilled, (state, action: PayloadAction<any>) => {
        state.licenseApproveOrReject.isLoading = false;
        state.licenseApproveOrReject.isSuccess = true;
        state.licenseApproveOrReject.message = action.payload.message;
      })
      .addCase(licenseApproveOrReject.rejected, (state, action: PayloadAction<any>) => {
        state.licenseApproveOrReject.isLoading = false;
        state.licenseApproveOrReject.isError = true;
        state.licenseApproveOrReject.message = action.payload;
      })
      .addCase(editLicense.pending, (state, action: PayloadAction<any>) => {
        state.editLicense.isLoading = true;
      })
      .addCase(editLicense.fulfilled, (state, action: PayloadAction<any>) => {
        state.editLicense.isLoading = false;
        state.editLicense.isSuccess = true;
        state.editLicense.message = action.payload.message;
      })
      .addCase(editLicense.rejected, (state, action: PayloadAction<any>) => {
        state.editLicense.isLoading = false;
        state.editLicense.isError = true;
        state.editLicense.message = action.payload;
      })
      .addCase(uploadUsers.pending, (state, action: PayloadAction<any>) => {
        state.uploadUsers.isLoading = true;
      })
      .addCase(uploadUsers.fulfilled, (state, action: PayloadAction<any>) => {
        state.uploadUsers.isLoading = false;
        state.uploadUsers.isSuccess = true;
        state.uploadUsers.message = action.payload.message;
      })
      .addCase(uploadUsers.rejected, (state, action: PayloadAction<any>) => {
        state.uploadUsers.isLoading = false;
        state.uploadUsers.isError = true;
        state.uploadUsers.message = action.payload;
      })
      .addCase(checkNetworkDuplication.pending, (state, action: PayloadAction<any>) => {
        state.checkNetworkDuplication.isLoading = true;
      })
      .addCase(checkNetworkDuplication.fulfilled, (state, action: PayloadAction<any>) => {
        state.checkNetworkDuplication.isLoading = false;
        state.checkNetworkDuplication.isSuccess = true;
        state.checkNetworkDuplication.message = action.payload.message;
        state.checkNetworkDuplication.checkNetworkDuplicationData = action.payload.result;
      })
      .addCase(checkNetworkDuplication.rejected, (state, action: PayloadAction<any>) => {
        state.checkNetworkDuplication.isLoading = false;
        state.checkNetworkDuplication.isError = true;
        state.checkNetworkDuplication.message = action.payload;
      })
  },
});

export const {
  resetAcceptOrRejectRequest,
  resetFetchRequestLists,
  resetFetchONRoles,
  resetFetchONSpecialities,
  resetAddONUser,
  resetFetchONMemberShipPlans,
  resetRegisterMembership,
  resetDeleteONUserRequest,
  resetEditONRequest,
  resetFetchONUserDetails,
  resetLicenseApproveOrReject,
  resetEditLicense,
  resetUploadUsers,
  resetCheckNetworkDuplication
} = requestLIstsSlice.actions;

export default requestLIstsSlice.reducer;